module.exports = __webpack_public_path__ + "img/shipo-icon-eye.32c03f17.svg";